// Module
var code = "<a href=\"javascript:;\" tabindex=\"-1\" class=\"btn blue-sharp subFormControl\"> <i class=\"icon-pointer\"></i> Google Maps </a>";
// Exports
export default code;